import { Box, Grid2 } from '@mui/material';
import CustomDialog from '@ui-components/Dialog/CustomDialog';
import CustomDialogContent from '@ui-components/Dialog/CustomDialogContent';
import CustomDialogActions from '@ui-components/Dialog/CustomDialogActions';
import { useNavigate } from 'react-router-dom';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomButton from '@ui-components/Button/CustomButton';

interface ConfirmDiscardDialogProps {
  open: boolean;
  onClose: () => void;

  navigateTo: string;
  navigationState?: Record<string, unknown>;

  title?: string;
  description?: string;
  type?: string;
  id?: number;
}

const ConfirmDiscardDialog = ({
  open,
  onClose,
  navigateTo,
  navigationState,
  title = 'Discard Changes?',
  description = 'All unsaved progress will be lost. Do you still wish to discard changes?',
  type,
  id,
}: ConfirmDiscardDialogProps) => {
  const navigate = useNavigate();

  const handleDiscard = () => {
    onClose();
    if (type) {
      if (type === 'facility') {
        navigate(navigateTo, {
          state: {
            facilityName: navigationState?.facilityName,
            type: type,
            ids: id,
          },
          replace: true,
        });
      } else {
        navigate(navigateTo, {
          state: {
            providerName: navigationState?.facilityName,
            type: type,
            ids: id,
          },
          replace: true,
        });
      }
    } else {
      navigate(navigateTo, {
        state: navigationState,
        replace: true,
      });
    }
  };

  return (
    <CustomDialog
      id="confirm-dialog"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown
    >
      <CustomDialogContent className="intake-dialog-width">
        <Box className="pb-8">
          <CustomTypography id="confirm-dialog-title" variant="h4">
            {title}
          </CustomTypography>
        </Box>

        <CustomTypography
          id="confirm-dialog-description"
          variant="body3"
          color="textDisabled"
        >
          {description}
        </CustomTypography>
      </CustomDialogContent>

      <CustomDialogActions>
        <Grid2 container>
          <Grid2 className="mr-8">
            <CustomButton
              id="discard-button"
              color="primary"
              variant="outlined"
              onClick={handleDiscard}
            >
              Discard
            </CustomButton>
          </Grid2>

          <Grid2>
            <CustomButton
              id="continue-editing-button"
              color="primary"
              variant="contained"
              onClick={onClose}
            >
              Continue Editing
            </CustomButton>
          </Grid2>
        </Grid2>
      </CustomDialogActions>
    </CustomDialog>
  );
};

export default ConfirmDiscardDialog;
